import GLightbox from "glightbox";
import React, { useEffect } from "react";
import { FiPlay } from "react-icons/fi";
import data from "../data/media.json";

const Media = ({isBg}) => {
  const { media } = data;
  useEffect(() => {
    GLightbox({
      selector: ".glightbox3",
    });
  }, []);

  return (
<>
    <section
      id="media"
      className={`section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      style={{padding:"100px 0 0 0"}}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{media.subtitle}</span>
              <h2 className="display-6">{media.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>

          </div>
    </section>
   {/* <!-- list start --> */}
    {media.chapters?.map((data) => (


 <section
      className={`section-padding ctav4 ${isBg === "yes" ? "bg-one": "" }`}
      style={{backgroundImage: `url(${data.backgroundImage})`}}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6 mb-4 mb-lg-0 ctav4__content">
            <h3
              className="display-3"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="150"
            >
              {data.title}
            </h3>
            <h3
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              {data.subtitle}
            </h3>
            <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="250">
              {data.text}
            </p>

            {data.btnText === "" ? ( "" ): (
              <a
                href={data.btnURL}
                className="smooth button button__primary"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="300"
              >
                <span>{data.btnText}</span>
              </a>
            )}
          </div>
          <div
            className="col-md-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="250"
          >
            <div className="ctav4__video-btn">
              {data.videoURL === "" ? (
                ""
              ) : (
                <>
                  <a href={data.videoURL} className="glightbox3 video-btn">
                    <FiPlay />
                  </a>
                  <div className="promo-video">
                    <div className="waves-block">
                      <div className="waves wave-1"></div>
                      <div className="waves wave-2"></div>
                      <div className="waves wave-3"></div>
                    </div>
                  </div>
                </>
              )}
              

            </div>
          </div>
        </div>
      </div>
    </section>

              ))}
  
   
   

 </>
     // <!-- ========== Media section end ========== -->
    
  );
};

export default Media;
